<template>
  <lazy-div :title="title" :breadcrumb="breadcrumb" :load="doInit">
    <v-card>
      <form data-vv-scope="statsTypeForm">
        <v-card-title>
          <div>
            <div class="headline">Summary</div>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-title>
          <div class="body-2">{{labels.general}}</div>
        </v-card-title>
        <v-card-text>
          <message :messages="messages" v-if="!statsValueDialog"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newStatsType">
                <v-text-field :label="labels.statsType" v-model="statsTypeForm.statsType" :error-messages="errors.collect('statsTypeForm.statsType')" v-validate="'required|param|max:4'" data-vv-name="statsType" :data-vv-as="labels.statsType"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.statsType}}</v-subheader>
                <div class="subheading">{{statsTypeForm.statsType}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field :label="labels.statsTypeDesc" v-model="statsTypeForm.statsTypeDesc" :error-messages="errors.collect('statsTypeForm.statsTypeDesc')" v-validate="'required|entry|max:40'" data-vv-name="statsTypeDesc" :data-vv-as="labels.statsTypeDesc"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-title>
          <div class="body-2">{{labels.riskFactor}}</div>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox :label="labels.mtrRiskFact" v-model="statsTypeForm.mtrRiskFact"></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox :label="labels.pkgRiskFact" v-model="statsTypeForm.pkgRiskFact"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </form>
      <v-divider></v-divider>
      <v-card-title>
        <div>
          <div class="headline">{{labels.valueList}}</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="statsVal" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.statsVal }}</td>
          <td class="text-xs-left">{{ props.item.statsValDesc }}</td>
          <td class="text-xs-center">
            <v-checkbox v-model="props.item.defAsBen" @change="changeDefaultValue(props.item.statsVal)" :disabled="props.item.defAsBen"></v-checkbox>
          </td>
          <td class="text-xs-right">
            <table-action :rowData="props" review :remove="canDelete(props)" @review="doReview" @remove="doRemove"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-dialog v-model="statsValueDialog" max-width="500px" persistent>
        <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew">Add Value</v-btn>
        <v-card>
          <v-card-title>
            <span class="headline">{{ labels.valueFormTitle }}</span>
          </v-card-title>
          <v-card-text>
            <message :messages="messages"></message>
            <form data-vv-scope="statsValueForm">
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex xs6 v-if="newStatsValue">
                    <v-text-field data-vv-scope="statsValueForm" v-model="statsValForm.statsVal" :label="labels.statsVal" :error-messages="errors.collect('statsValueForm.statsVal')" data-vv-name="statsVal" :data-vv-as="labels.statsVal" v-validate="'required|param|max:4'"></v-text-field>
                  </v-flex>
                  <v-flex xs6 v-else>
                    <v-subheader class="queryLabel">{{labels.statsVal}}</v-subheader>
                    <div class="subheading">{{statsValForm.statsVal}}</div>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field data-vv-scope="statsValueForm" v-model="statsValForm.statsValDesc" :label="labels.statsValDesc" :error-messages="errors.collect('statsValueForm.statsValDesc')" v-validate="'required|entry|max:40'" data-vv-name="statsValDesc" :data-vv-as="labels.statsValDesc"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="dialogStatsValueClose">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="statsValSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn color="primary" @click.native="saveAllStats">
        Save
        <v-icon right></v-icon>
      </v-btn>
    </v-card>
  </lazy-div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import FieldMixin from '@/mixins/field'
import MessageMixin from '@/mixins/message'
export default {
  props: ['id'],
  data() {
    return {
      breadcrumb: [],
      headers: [
        { text: 'Statistics Value Code', value: 'statsVal' },
        { text: 'Statistics Value Description', value: 'statsValDesc' },
        { text: 'Default As Benefit', value: 'defAsBen' },
        TableConst.tableActionHeader
      ],
      labels: {
        general: 'Statistics Details',
        riskFactor: 'Risk Factor',
        valueList: 'Value Listing',
        valueFormTitle: 'Value Details',
        statsType: 'Statistics Type Code',
        statsTypeDesc: 'Statistics Type Description',
        mtrRiskFact: 'Motor',
        pkgRiskFact: 'Package',
        statsVal: 'Statistics Value Code',
        statsValDesc: 'Statistics Value Description'
      },
      statsValueIndex: -1,
      statsValForm: {
        statsType: null,
        statsVal: null,
        statsValDesc: null,
        defAsBen: null,
        removeMode: null
      },
      statsTypeForm: {
        statsType: null,
        statsTypeDesc: null,
        mtrRiskFact: false,
        pkgRiskFact: false
      },
      defaultItems: [],
      newStatsValue: undefined,
      newStatsType: null,
      statsValueDialog: undefined
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumbByName'
    ]),
    title() {
      if (this.newStatsType) {
        return 'New Statistics'
      } else {
        return 'Review Statistics'
      }
    },
    statistics() {
      return this.$store.state.parameters.statistics
    },
    noDataText() {
      if (this.newStatsType) {
        return 'Please add some statistics value'
      } else {
        return ''
      }
    }
  },
  methods: {
    async statsTypeFormInit() {
      const apiURI = this.statistics.menu.StatsType
      if (apiURI) {
        try {
          const expand = {
            statsType: this.id
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.statsTypeForm.statsType = data.statsType.statsType
            this.statsTypeForm.statsTypeDesc = data.statsType.statsTypeDesc
            this.statsTypeForm.mtrRiskFact = data.statsType.mtrRiskFact
            this.statsTypeForm.pkgRiskFact = data.statsType.pkgRiskFact
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doInit() {
      this.loading = true
      const apiURI = this.statistics.menu.StatsValues
      if (apiURI) {
        try {
          const expand = {
            statsType: this.id
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((statsVal) => {
              const convertStatsVal = {
                statsVal: statsVal.statsVal,
                statsValDesc: statsVal.statsValDesc,
                defAsBen: statsVal.defAsBen,
                removeMode: false
              }
              this.items.push(convertStatsVal)
            })
            this.cloneItems(this.items)
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    cloneItems(items) {
      this.defaultItems = JSON.parse(JSON.stringify(items))
    },
    doReview(data) {
      this.newStatsValue = false
      this.statsValueDialog = true
      this.statsValueIndex = data.index
      this.statsValForm.statsVal = data.item.statsVal
      this.statsValForm.statsValDesc = data.item.statsValDesc
    },
    canDelete(data) {
      if (data.item.removeMode) {
        if (!data.item.defAsBen) {
          return true
        } else {
          return false
        }
      }
    },
    dialogStatsValueClose() {
      this.statsValueDialog = false
      this.statsValForm.statsVal = null
      this.statsValForm.statsValDesc = null
      this.resetValidator()
      this.resetMessages()
    },
    doNew() {
      this.newStatsValue = true
      this.statsValueDialog = true
    },
    statsValSave() {
      this.resetMessages()
      this.$validator.validateAll('statsValueForm').then(result => {
        if (result) {
          if (this.newStatsValue) {
            this.doNewValue()
          } else {
            this.doEditValue()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doNewValue() {
      if (!this.duplicateKey(this.statsValForm.statsVal) || !this.duplicateDesc(this.statsValForm.statsValDesc)) {
        if (!this.duplicateKey(this.statsValForm.statsVal)) {
          if (!this.duplicateDesc(this.statsValForm.statsValDesc)) {
            const pushObj = {
              statsVal: this.statsValForm.statsVal.trim(),
              statsValDesc: this.statsValForm.statsValDesc.trim(),
              defAsBen: false,
              removeMode: true
            }
            this.items.push(pushObj)
            this.dialogStatsValueClose()
          } else {
            this.errorMessage('Duplicate Statstics Value Description was found')
          }
        } else {
          this.errorMessage('Duplicate Statstics Value Code was found')
        }
      } else {
        this.errorMessage('Duplicate Statstics Value was found')
      }
    },
    doEditValue() {
      const pushObj = {
        statsVal: this.statsValForm.statsVal.trim(),
        statsValDesc: this.statsValForm.statsValDesc.trim()
      }
      Object.assign(this.items[this.statsValueIndex], pushObj)
      this.dialogStatsValueClose()
    },
    doRemove(data) {
      this.items.splice(data.index, 1)
    },
    resetForm() {
      this.statsValForm.statsVal = undefined
      this.statsValForm.statsValDesc = undefined
    },
    duplicateKey(key) {
      var found = this.items.some(function (el) {
        return el.statsVal === key
      })
      if (found) {
        return true
      }
    },
    duplicateDesc(key) {
      var found = this.items.some(function (el) {
        return el.statsValDesc === key
      })
      if (found) {
        return true
      }
    },
    changeDefaultValue(data) {
      // Set All to defAsBen to false
      this.items.map(function (item) {
        item.defAsBen = false
        return item
      })
      // find specific item of index
      const index = this.items.findIndex(item => item.statsVal === data)
      // Set specific item of defAsBen to true
      this.items[index].defAsBen = true
    },
    async saveAllStats() {
      this.resetMessages()
      this.$validator.validateAll('statsTypeForm').then(result => {
        if (result) {
          let defVal = this.items.some(function (item) {
            return item.defAsBen === true
          })
          if (defVal || this.items.length > 1) {
            if (defVal) {
              if (this.items.length > 1) {
                if (this.newStatsType) {
                  this.doCreateType()
                  this.$router.push({ name: 'statistics' })
                } else {
                  // filter the items list
                  const DefItems = this.defaultItems.filter(this.comparer(this.items))
                  const UpdateItems = this.items.filter(this.comparer(this.defaultItems))
                  const resultCreate = DefItems.concat(UpdateItems)
                  const resultUpdate = this.items.filter(this.comparer(resultCreate))
                  if (resultCreate.length > 0) {
                    for (let index = 0; resultCreate.length > index; index++) {
                      this.doCreateValue(resultCreate[index])
                    }
                  } else {
                    for (let index = 0; resultUpdate.length > index; index++) {
                      this.doUpdateValue(resultUpdate[index])
                    }
                  }
                  this.doUpdateType()
                  this.$router.push({ name: 'statistics' })
                }
              } else {
                this.errorMessage('At least contains 2 statistics value')
              }
            } else {
              this.errorMessage('Please Choose a Default Value')
            }
          } else {
            this.errorMessage('Please Choose a Default Value and at least contains 2 statistics value')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateValue(obj) {
      const apiURI = this.statistics.menu.StatsValueCreate
      if (this.newStatsType) {
        obj['statsType'] = this.statsTypeForm.statsType
      } else {
        obj['statsType'] = this.id
      }
      if (apiURI) {
        this.submitting = true
        try {
          const result = this.$http.post(apiURI, obj)
          const { data } = await result
          if (data) {
            return true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      }
    },
    async doUpdateValue(obj) {
      const apiURI = this.statistics.menu.StatsValueUpdate
      obj['statsType'] = this.id
      if (apiURI) {
        this.submitting = true
        try {
          const result = this.$http.put(apiURI, obj)
          const { data } = await result
          if (data) {
            return true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      }
    },
    async doCreateType() {
      const apiURI = this.statistics.menu.StatsTypeCreate
      if (apiURI) {
        this.submitting = true
        try {
          const resultTypeForm = {
            statsType: this.statsTypeForm.statsType.trim(),
            statsTypeDesc: this.statsTypeForm.statsTypeDesc.trim(),
            mtrRiskFact: this.statsTypeForm.mtrRiskFact,
            pkgRiskFact: this.statsTypeForm.pkgRiskFact
          }
          const result = await this.$http.post(apiURI, resultTypeForm)
          const { data } = result
          if (data) {
            this.notify(data)
            for (let index = 0; this.items.length > index; index++) {
              this.doCreateValue(this.items[index])
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      }
    },
    async doUpdateType() {
      const apiURI = this.statistics.menu.StatsTypeUpdate
      if (apiURI) {
        this.submitting = true
        try {
          const resultTypeForm = {
            statsType: this.statsTypeForm.statsType.trim(),
            statsTypeDesc: this.statsTypeForm.statsTypeDesc.trim(),
            mtrRiskFact: this.statsTypeForm.mtrRiskFact,
            pkgRiskFact: this.statsTypeForm.pkgRiskFact
          }
          const result = await this.$http.put(apiURI, resultTypeForm)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    comparer(otherArray) {
      return function (current) {
        return otherArray.filter(function (other) {
          return other.statsVal === current.statsVal
        }).length === 0
      }
    }
  },
  mounted() {
    this.breadcrumb = this.derieveBreadcrumbByName('statstistics')
    this.breadcrumb.push({
      name: 'statsReview',
      text: this.title
    })
    if (this.id === 'new') {
      this.loading = false
      this.newStatsType = true
    }
  },
  created() {
    if (this.id === 'new') {
      this.newStatsType = true
    } else {
      Promise.all([this.statsTypeFormInit(), this.doInit()])
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>
</style>
